import { useCallback, useEffect, useRef, useState } from "react";
import { getRequest } from "../../utils/api";
import { logout } from "../../utils/auth";
import { toast } from "react-toastify";
import PaginationComponent from "../../Component/Pagination/pagination";
import moment from "moment";
import AddSubscriptionModal from "./modal/AddSubscriptionModal";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import InvoiceTemplate from "./invoiceDowloadTemplate";
import Loader from "../../Component/Loader/Loader";
const SubscriptionNew = () => {
  const [showInvoice, setShowInvoice] = useState(false);
  const [invoiceItem, setInvoiceItem] = useState<any>({});
  const [isLoader, setIsLoader] = useState<any>(true);
  const [dataList, setDataList] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const [showModal, setShowModal] = useState(false);
  const [editStation, setEditStation] = useState(null);

  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const getDataList = useCallback(async (currentPage: number) => {
    try {
      setIsLoader(true)
      const response = await getRequest(`/subscription/subscriptions?page=${currentPage}&activeTab=All`);
      if (response.status === 'success') {
        setDataList(response.data as any[])
        setIsLoader(false);
        setTotalPages(response.pagination.totalPages);
        setTotalRecords(response.pagination.totalRecords);
      }
      else if (response.status == 'session_expired') {
        setIsLoader(false)
        logout()
      }
      else {
        setIsLoader(false)
        toast.error(response.message);
      }
    } catch (error) {
      setIsLoader(false)
      toast.error("Something went wrong!");
    }
  }, []);

  const isFirstRender = useRef(false);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = true;
      return;
    }
    getDataList(page);
  }, [page]);

  const invoiceRef = useRef<HTMLDivElement>(null);

  const handleDownloadPDF = async (item: any) => {
    setShowInvoice(true)
    setInvoiceItem(item)
    setTimeout(async () => {
      const element = invoiceRef.current;
      if (!element) return;

      const canvas = await html2canvas(element, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`invoice_${Date.now()}.pdf`);
      setShowInvoice(false)
    }, 100);
  };

  return (
    <>
      {showInvoice && (<Loader />)}
      <div className="hk-pg-wrapper">
        <div className="hk-pg-body py-0">
          <div className="page-wrap">
            <div className="page-content ps-0">
              <div className="page-detail-wrap">
                <header className="page-header">
                  <div>
                    <div className="page-title">
                      <div>
                        <h2 className="mb-1">Manage Billing & Subscription</h2>
                        <p className="fs-13">Control billing cycles, invoices, and active subscriptions</p>
                      </div>
                    </div>
                  </div>
                  <div className="page-options-wrap">
                    <div className="v-separator d-lg-inline-block d-none"></div>
                    <button type="button" className="btn btn-dark btn-rounded" onClick={() => setShowModal(true)}>
                      <span>
                        <span className="icon"><i className="ri-add-line bticon"></i></span>
                        <span>Create New</span>
                      </span>
                    </button>
                    <a className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover hk-navbar-togglable d-lg-inline-block d-none"
                      href="#" data-bs-toggle="tooltip" data-bs-placement="top" title=""
                      data-bs-original-title="Collapse">
                      <span className="btn-icon-wrap">
                        <span className="feather-icon"><i className="ri-arrow-up-s-line ri-lg"></i></span>
                        <span className="feather-icon d-none"><i className="ri-arrow-down-s-line ri-lg"></i></span>
                      </span>
                    </a>
                  </div>
                </header>
                <div className="page-body">
                  <div data-simplebar className="nicescroll-bar">
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="card">
                            <div className="table-responsive">
                              
                            </div>
                            {/* <div className="card-footer d-flex justify-content-between align-items-center">
                              <div className="col-sm">
                                <div className="text-muted">Showing <span className="fw-semibold">{dataList?.length || 0}</span> of <span className="fw-semibold">{totalRecords || 0}</span> Results</div>
                              </div>
                              {totalPages > 0 && <PaginationComponent totalPages={totalPages} currentPage={page} setCurrentPage={setPage} />}
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AddSubscriptionModal
          show={showModal}
          onHide={() => {
            setShowModal(false);
            setEditStation(null);
          }}
          editData={editStation}
        />
      </div>
      {invoiceItem && showInvoice && <InvoiceTemplate invoiceItem={invoiceItem} invoiceRef={invoiceRef}></InvoiceTemplate>}
    </>
  );
}
export default SubscriptionNew